import { FeatureFlagsType, getFeatureFlag } from '../../config/launch-darkly/FeatureFlagsController';
import { UserOrigin } from '../../organization/users/enums/UserOrigin';
import { UserRole, getUserRoleLabel } from '../../organization/users/enums/UserRole';
import { UserLevel } from './UserLevel';

export class User {
  constructor(
    private readonly id: number | string,
    private readonly name: string,
    private readonly preferredName: string | null,
    private readonly level: UserLevel,
    private readonly roles: UserRole[],
    private readonly origin: UserOrigin,
    private readonly organizationUUID: string
  ) {}

  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  getPreferredName() {
    return this.preferredName;
  }

  getLevel() {
    return this.level;
  }

  getRoles() {
    return this.roles;
  }

  getOrigin() {
    return this.origin;
  }

  getFormattedName() {
    const name = this.getPreferredName() || this.getName();
    const useRoles = getFeatureFlag(FeatureFlagsType.ENABLE_ORGANIZATION_USER_ROLES);
    if (useRoles) {
      return `${name} (${this.roles.map(getUserRoleLabel).join(', ')})`;
    }
    return `${name} (${this.getLevel()})`;
  }

  getOrganizationUUID() {
    return this.organizationUUID;
  }
}
